import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Payments = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <g clipPath="url(#clip0_130_6407)">
        <path
          d="M5.66668 9.7778C5.66668 10.6369 6.36312 11.3333 7.22221 11.3333H8.66668C9.58714 11.3333 10.3333 10.5871 10.3333 9.66667C10.3333 8.7462 9.58714 8 8.66668 8H7.33334C6.41287 8 5.66668 7.2538 5.66668 6.33333C5.66668 5.41286 6.41287 4.66667 7.33334 4.66667H8.77781C9.63688 4.66667 10.3333 5.36311 10.3333 6.22222M8.00001 3.66667V4.66667M8.00001 11.3333V12.3333M14.6667 8C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8C1.33334 4.3181 4.31811 1.33333 8.00001 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8Z"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_130_6407">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default withStyles(Payments);
